export var HERO_TYPE;(function(HERO_TYPE){HERO_TYPE[HERO_TYPE["CAROUSEL"]=0]="CAROUSEL";HERO_TYPE[HERO_TYPE["STATIC"]=1]="STATIC";})(HERO_TYPE||(HERO_TYPE={}));